<script>
import Layout from "../../layouts/main";
import ExportButton from "@/components/export-button";
import axios from "@/axios";
export default {
  components: {
    Layout,
    "export-button": ExportButton
  },
  data() {
    return {
      numeroDocumento: this.$route.params.id,
      fields: [
        {
          key: "name",
          label: "Documento",
          sortable: false,
        },
        {
          key: "descarga",
          label: "Descarga",
          sortable: false,
        },
      ],
      tableData: [],
      isBusy: true,
      buttonClicked: undefined
    };
  },
  beforeMount() {
    this.getDocuments();
  },
  methods:{
    getDocuments() {
      this.isBusy = true;
      axios
        .get(`/GetDocumentosDeGastos?contrato=${this.numeroDocumento}`)
        .then((docs) => {
          this.tableData = docs.data
          this.isBusy = false;
        })
        .catch(() => {
            this.isBusy = false;
            this.$bvToast.toast(this.$t('lease.request.error.message').toString(), {
                title: this.$t('lease.request.error.nonFound').toString(),
                variant: 'danger',
                solid: true
            });
        });
    },
    downloadDocumento(row){
      axios.get(`/DescargarDocumentoDeGastos?id=${row.item.idDocumento}`)
      .then(documento => {
        if (documento.data.pdf) {
            const blob = this.b64toBlob(
              documento.data.pdf,
              "application/pdf"
            );
            let fileURL = window.URL.createObjectURL(blob);
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              `${row.item.name}.pdf`
            );
            document.body.appendChild(fileLink);

            fileLink.click();
            this.buttonClicked = undefined;
          }else{
            this.$bvToast.toast(this.$t('lease.pdf.error.nonFound').toString(), {
                title: this.$t('lease.pdf.error.download').toString(),
                variant: 'danger',
                solid: true
            });
        }
      })
      .catch(() => this.$bvToast.toast(this.$t('lease.pdf.error.nonFound').toString(), {
          title: this.$t('lease.pdf.error.download').toString(),
          variant: 'danger',
          solid: true
      }));
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  }
};
</script>
<template>
  <Layout>
    <div classs="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center" class="mb-3">
              <h4 class="card-tittle">DOCUMENTOS GASTOS REEMBOLSABLES</h4>
              <export-button :data="tableData" fileName="documentos" />
            </b-row>
            <b-row>
              <b-col sm="12" md="6" offset-md="6" lg="4" offset-lg="8">
                <b-form-group label="Ítem" label-for="formrow-name-input">
                  <b-form-input
                    id="formrow-name-input"
                    v-model="numeroDocumento"
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="container">
              <b-table 
              :items="tableData" 
              :fields="fields"
              responsive="sm" 
              :busy="isBusy"
              class="text-center"
              >

                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->

                <template #cell(descarga)="row">
                  <div class="text-center">
                    <b-button variant="danger" @click="downloadDocumento(row)">
                      <i v-if="buttonClicked !== row.item.name" class="bx bx-download font-size-16 align-middle" />
                      <b-spinner v-else small class="align-middle"></b-spinner>
                      Descargar
                    </b-button>
                  </div>
                </template>

              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
</style>
